import { render, staticRenderFns } from "./DisqusThread.vue?vue&type=template&id=a0ee11ba"
import script from "./DisqusThread.vue?vue&type=script&lang=js"
export * from "./DisqusThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports